import React from 'react'
import {Routes, Route} from 'react-router-dom' 
import './App.css'
import MenPro from './shopping/components/products/secproducts/MenPro';
import MainPage from './shopping/pages/MainPage';

import "primereact/resources/themes/lara-light-indigo/theme.css";     
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";                                         
import ImageGallery from './shopping/components/products/mens/ImageGallery';
import AutoImageSlider from './AutoImageSlider';
import MenSuit from './shopping/components/products/mens/MenSuit';
import FilterSec from './FilterSec';
import SingleProduct from './shopping/components/products/singleproducts/SingleProduct';
import Sample from './Sample';
import MenProducts from './shopping/pages/allProducts/MenProducts';
import SingleExt from './shopping/pages/allProducts/SingleExt';
import WomanProducts from './shopping/pages/allProducts/WomanProducts';
import WSingleExt from './shopping/pages/allProducts/WSingleExt';
import AddToCartPage from './Sample';
import CartPage from './shopping/pages/CartPage';

const images = [
  'https://via.placeholder.com/500x300',
  'https://via.placeholder.com/500x301',
  'https://via.placeholder.com/500x302',
  'https://via.placeholder.com/500x303',
];

        

const App = () => {
  return (
    <div >
      <Routes>
        <Route path='/' element={<MainPage />} />
        {/* <Route path='/single' element={<SingleProduct />} /> */}
        <Route path='/men' element ={<MenPro />} />
        <Route path='/sample' element = {<Sample />} />
        <Route path='/mens' element={<MenProducts />} />
        <Route path='/woman' element={<WomanProducts />} />
        <Route path='/multi/:id' element = {<SingleExt />} />
        <Route path= '/w-multi/:id' element = {<WSingleExt />} />
        <Route path='/cart' element={<CartPage />} />
      </Routes>
        {/* <Route path='/see/abc' element={<MultiSingle />} /> */}
      {/* <MenSuit /> */}
      {/* <MenPro /> */}
      {/* <FilterSec /> */}
      {/* <SingleProduct /> */}
    </div>
  )
}

export default App